"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
exports.MessageKeyFactory = immutable_1.Record({ name: 'default', languageId: -1 });
exports.MessageFactory = immutable_1.Record({
    key: exports.MessageKeyFactory(),
    value: 'default',
});
//# sourceMappingURL=factories.js.map